import React from 'react';
import { TabContent, TabContentProps } from 'reactstrap';
import { useTabContainer } from './ContainerContext';

const Content = ({ children, ...rest }: TabContentProps) => {
  const { activeTab } = useTabContainer();
  return (
    <TabContent {...rest} activeTab={activeTab}>
      {children}
    </TabContent>
  );
};
export default Content;
